import Component from '../classes/component';

class Backdrop extends Component {
  private _isOpened = false;

  private _onClick: () => void = null;

  private _handleClick() {
    if (this._onClick) {
      this._onClick();
      this._onClick = null;
    }
  }

  public open(onClick?: () => void) {
    this._isOpened = true;
    this.container.classList.add('is-opened');
    if (onClick) this._onClick = onClick;
  }

  public close() {
    this._isOpened = false;
    this.container.classList.remove('is-opened');
  }

  public get isOpened() {
    return this._isOpened;
  }

  protected _onEnter() {
    this._addListener(this.container, 'click', this._handleClick);
  }
}

export default Backdrop;
